import type { AgentChatTurnResponse } from '@/apis/logiblocksAgentAPI';

/**
 * Preparation does not increment the main session version. A question carried
 * by a preparation response is therefore current after an answer only when it
 * observes the answer's version and is not the question that was just answered.
 */
export function isPostAnswerPreparationQuestionCurrent(
  preparation: AgentChatTurnResponse | null,
  answerAcknowledgement: AgentChatTurnResponse,
  answeredQuestionId: string
): preparation is AgentChatTurnResponse {
  return Boolean(
    preparation?.question &&
    preparation.session_state_version ===
      answerAcknowledgement.session_state_version &&
    preparation.question.question_id !== answeredQuestionId
  );
}
